// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.number {
  background: #fff;
  position: relative;
  font: 900 30vmin "Consolas";
  letter-spacing: 5vmin;
  text-shadow: 2px -1px 0 #000, 4px -2px 0 #0a0a0a, 6px -3px 0 #0f0f0f,
    8px -4px 0 #141414, 10px -5px 0 #1a1a1a, 12px -6px 0 #1f1f1f,
    14px -7px 0 #242424, 16px -8px 0 #292929;
}
.number::before {
  background-color: #673ab7;
  background-image: radial-gradient(
      closest-side at 50% 50%,
      #ffc107 100%,
      rgba(0, 0, 0, 0)
    ),
    radial-gradient(closest-side at 50% 50%, #e91e63 100%, rgba(0, 0, 0, 0));
  background-repeat: repeat-x;
  background-size: 40vmin 40vmin;
  background-position: -100vmin 20vmin, 100vmin -25vmin;
  width: 100%;
  height: 100%;
  mix-blend-mode: screen;
  animation: moving 10s linear infinite both;
  display: block;
  position: absolute;
  content: "";
}
@keyframes moving {
  to {
    background-position: 100vmin 20vmin, -100vmin -25vmin;
  }
}

.text {
  text-align: center;
  -webkit-user-select: none;
          user-select: none;
  font-size: 50px;
}
.text span {
  font-size: 10vmin;
}

.wrapper {
  display: flex;
  flex-direction: column;
  height: 90vh;
  justify-content: center;
  align-items: center;
}

.redirect-home {
  text-align: center;
  cursor: pointer;
  font-size: 25px;
  color: #fff;
  background-color: #f1ab28;
  padding: 15px 1px 15px 1px;
  border-radius: 20px;
}

.redirect-home:hover {
  text-align: center;
  cursor: pointer;
  background-color: #f09001;
  border-radius: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/NotFoundPage/NotFoundPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,qBAAqB;EACrB;;4CAE0C;AAC5C;AACA;EACE,yBAAyB;EACzB;;;;;4EAK0E;EAC1E,2BAA2B;EAC3B,8BAA8B;EAC9B,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,sBAAsB;EAEtB,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AAMA;EACE;IACE,qDAAqD;EACvD;AACF;;AAEA;EACE,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":[".number {\n  background: #fff;\n  position: relative;\n  font: 900 30vmin \"Consolas\";\n  letter-spacing: 5vmin;\n  text-shadow: 2px -1px 0 #000, 4px -2px 0 #0a0a0a, 6px -3px 0 #0f0f0f,\n    8px -4px 0 #141414, 10px -5px 0 #1a1a1a, 12px -6px 0 #1f1f1f,\n    14px -7px 0 #242424, 16px -8px 0 #292929;\n}\n.number::before {\n  background-color: #673ab7;\n  background-image: radial-gradient(\n      closest-side at 50% 50%,\n      #ffc107 100%,\n      rgba(0, 0, 0, 0)\n    ),\n    radial-gradient(closest-side at 50% 50%, #e91e63 100%, rgba(0, 0, 0, 0));\n  background-repeat: repeat-x;\n  background-size: 40vmin 40vmin;\n  background-position: -100vmin 20vmin, 100vmin -25vmin;\n  width: 100%;\n  height: 100%;\n  mix-blend-mode: screen;\n  -webkit-animation: moving 10s linear infinite both;\n  animation: moving 10s linear infinite both;\n  display: block;\n  position: absolute;\n  content: \"\";\n}\n@-webkit-keyframes moving {\n  to {\n    background-position: 100vmin 20vmin, -100vmin -25vmin;\n  }\n}\n@keyframes moving {\n  to {\n    background-position: 100vmin 20vmin, -100vmin -25vmin;\n  }\n}\n\n.text {\n  text-align: center;\n  user-select: none;\n  font-size: 50px;\n}\n.text span {\n  font-size: 10vmin;\n}\n\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 90vh;\n  justify-content: center;\n  align-items: center;\n}\n\n.redirect-home {\n  text-align: center;\n  cursor: pointer;\n  font-size: 25px;\n  color: #fff;\n  background-color: #f1ab28;\n  padding: 15px 1px 15px 1px;\n  border-radius: 20px;\n}\n\n.redirect-home:hover {\n  text-align: center;\n  cursor: pointer;\n  background-color: #f09001;\n  border-radius: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
